module.exports = __webpack_public_path__ + "img/pet blanket.191ef8db.svg";